import React, { useState } from "react";
import styles from './Contact.module.css';
import { apiUrl } from "../config/api";

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // PREVENT DEFAULT - IMPORTANT!
    
    setLoading(true);
    setSuccess('');
    setError('');

    try {
      console.log('📤 Sending form data:', formData);
      
      const response = await fetch(apiUrl('/api/contact'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      console.log('📥 Response status:', response.status);
      
      const data = await response.json();
      console.log('📄 Response data:', data);

      if (response.ok && data.success) {
        setSuccess(`Thank you! ${formData.name}, your message has been sent successfully.`);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        setError(data.message || 'Failed to send message. Please try again.');
      }
    } catch (err) {
      console.error('❌ Network error:', err);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ===== Contact Hero Section ===== */}
      <section className={styles.contactHero}>
        <div className={`container ${styles.contactContainer}`}>
          {/* Left side text */}
          <div className={styles.contactInfo}>
            <h2>Have a Comment?</h2>
            <h3>We're here to answer your questions and discuss.</h3> <h3> How we can work together for a better Afghanistan!</h3>
            
            <p>Kindly fill the form or reach us via the contact details below:</p>

            <div className={styles.contactDetails}>
              <div className={styles.contactCards}>
                <div className={styles.contactCard}>
                  <h4>
                    <i className="fas fa-phone"></i>
                    Phone Contact
                  </h4>
                  <p>+93 (0)730405003</p>
                  <p>+93 (0)20 2500 200</p>
                </div>

                <div className={styles.contactCard}>
                  <h4>
                    <i className="fas fa-map-marker-alt"></i>
                    Location
                  </h4>
                  <p>Kabul, Dehbori, Karwan University Street</p>
                </div>

                <div className={styles.contactCard}>
                  <h4>
                    <i className="fas fa-envelope"></i>
                    Email
                  </h4>
                  <p>info@nora.org.af</p>
                  <p>support@nora.org.af</p>
                </div>

                <div className={styles.contactCard}>
                  <h4>
                    <i className="fas fa-clock"></i>
                    Working Hours
                  </h4>
                  <p>Sunday  - Thursday</p>
                  <p>8:00 AM - 4:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right side form */}
          <div className={styles.contactForm}>
            <form className={styles.contactFormContent} onSubmit={handleSubmit}>
              {success && (
                <div className={styles.successMessage}>{success}</div>
              )}
              {error && (
                <div className={styles.errorMessage}>{error}</div>
              )}

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label>Full Name</label>
                  <input 
                    type="text" 
                    name="name"
                    placeholder="Your full name" 
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className={styles.formGroup}>
                  <label>Email</label>
                  <input 
                    type="email" 
                    name="email"
                    placeholder="email@service.com" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>
              </div>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label>Phone Number</label>
                  <input 
                    type="tel" 
                    name="phone"
                    placeholder="+93 xx xxx xxxx" 
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className={styles.formGroup}>
                  <label>Subject</label>
                  <input 
                    type="text" 
                    name="subject"
                    placeholder="The subject" 
                    value={formData.subject}
                    onChange={handleChange}
                    required 
                  />
                </div>
              </div>

              <div className={styles.formGroup}>
                <label>Message</label>
                <textarea 
                  rows={4} 
                  name="message"
                  placeholder="What do you have in mind?" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                  minLength={3}
                ></textarea>
              </div>

              <button type="submit" className={styles.btnSubmit} disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* ===== Map Section ===== */}
      <section className={styles.mapSection}>
        <iframe
          title="NORA Location - Kabul, Afghanistan"
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1252.0445387814261!2d69.12059722415732!3d34.51759810000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2s!4v1785675425771!5m2!1sen!2s"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        </section>
    </>
  );
};

export default Contact;